import { Store, Module, ActionContext } from 'vuex';
import AppConsts from '@/lib/appconst';
import ListModule from './list-module';
import ListState from './list-state';
import CaseLabel from '../entities/case-label';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import Ref from '../entities/ref';
import appconst from './../../lib/appconst';
import Util from '@/lib/util';
interface CaseLabelState extends ListState<CaseLabel> {
	statuses: Array<Ref>;
	items: Array<CaseLabel>;
}
class CaseLabelModule extends ListModule<CaseLabelState, any, CaseLabel> {
	state = {
		totalCount: 0,
		currentPage: 1,
		pageSize: 10,
		list: new Array<CaseLabel>(),
		items: new Array<CaseLabel>(),
		loading: false,
	};
	actions = {
		async getAll(context: ActionContext<CaseLabelState, any>, payload: any) {
			context.state.loading = true;
			const {
				data: { result },
			} = await Ajax.get('/api/services/app/CaseLabel/GetAll', { params: payload.data });
			context.state.loading = false;
			const page = result as PageResult<CaseLabel>;
			context.state.items = page.items;
			context.state.totalCount = page.totalCount;
			context.state.list = Util.pagingItems(page.items, context.state.pageSize, context.state.currentPage);
		},
		async create(context: ActionContext<CaseLabelState, any>, payload: any) {
			const {
				data: { result },
			} = await Ajax.post('/api/services/app/caseLabel/create-caseLabels', payload.data);
			return result;
		},
		async getListStatusesForSelect(context: ActionContext<CaseLabelState, any>) {
			var params = {
				tableName: AppConsts.tableRef.tableCaseLabel.name,
				columnName: AppConsts.tableRef.tableCaseLabel.column.status,
				prefix: AppConsts.tableRef.tableCaseLabel.prefix.status,
			};
			const {
				data: { result },
			} = await Ajax.get('/api/services/app/Product/GetRefsForSelect', { params: params });
			context.state.statuses = result.items as Ref[];
		},
		async exportCaseLabels(context: ActionContext<CaseLabelState, any>, payload: any) {
			var url = `${appconst.remoteServiceBaseUrl}export/ExportCaseLabels${abp.utils.buildQueryString(
				Object.keys(payload.data).map((key) => {
					return {
						name: key,
						value: payload.data[key],
					};
				}),
				true
			)}`;
			window.open(url, '_blank');
		},
		async print(context: ActionContext<CaseLabelState, any>, payload: any) {
			const {
				data: { result },
			} = await Ajax.post('/api/services/app/caseLabel/print-caseLabels', payload.data);
			return result;
		},
	};
	mutations = {
		setCurrentPage(state: CaseLabelState, page: number) {
			state.currentPage = page;
		},
		setPageSize(state: CaseLabelState, pagesize: number) {
			state.pageSize = pagesize;
		},
	};
}
const caseLabelModule = new CaseLabelModule();
export default caseLabelModule;
